import { render, staticRenderFns } from "./photosvideiosDocumentation.vue?vue&type=template&id=5ff9823a&"
import script from "./photosvideiosDocumentation.vue?vue&type=script&lang=js&"
export * from "./photosvideiosDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./photosvideiosDocumentation.vue?vue&type=style&index=0&id=5ff9823a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports